// extracted by mini-css-extract-plugin
export default {"controls":"WTGULjfTvBFhTcO6vd1f","inputBox":"_cQ0DZBHn7bffkCtuveH"};